import { each, go, last } from "fxjs/es";
import { PathEditorNS } from "../../../../../../PathEditor/PathEditorNS.js";
import { PROCESSING_TASK } from "./const.js";
export const _handleMouseMove = (self, event) => {
  if (!self._is_mouse_down) {
    return;
  }
  const rubber_band_layer_el = self._getRubberBandLayerElThrowable();
  const rubber_band = self._getRubberBandThrowable();
  const selection_translate_transform =
    self._getSelectionTranslateTransformThrowable();
  const selection_rotate_transform =
    self._getSelectionRotateTransformThrowable();
  const selection_scale_transform = self._getSelectionScaleTransformThrowable();
  const prev_mouse_move_position = self._mouse_move_position;
  const { clientX: client_x, clientY: client_y } = event;
  const mouse_move_point = self._toViewPortPoint({
    x: client_x,
    y: client_y,
  });
  self._is_mouse_move = true;
  self._mouse_move_position = {
    x: mouse_move_point.x,
    y: mouse_move_point.y,
  };
  switch (self._processing_task) {
    case PROCESSING_TASK.SELECTING: {
      const rubber_band_layer_ctm = rubber_band_layer_el.getCTM();
      if (rubber_band_layer_ctm == null) {
        throw new Error(
          `rubber_band_layer 엘리먼트의 CTM 을 구할 수 없습니다.`
        );
      }
      const rubber_band_layer_ctm_inverse = rubber_band_layer_ctm.inverse();
      const point = mouse_move_point.matrixTransform(
        rubber_band_layer_ctm_inverse
      );
      rubber_band.progressSelecting({
        x: point.x,
        y: point.y,
      });
      return;
    }
    case PROCESSING_TASK.TRANSLATE_TRANSFORMING: {
      selection_translate_transform.progress({
        x: mouse_move_point.x,
        y: mouse_move_point.y,
      });
      return;
    }
    case PROCESSING_TASK.ROTATE_TRANSFORMING: {
      selection_rotate_transform.progress({
        x1: self._rotate_transforming_origin_x,
        y1: self._rotate_transforming_origin_y,
        x2: mouse_move_point.x,
        y2: mouse_move_point.y,
      });
      return;
    }
    case PROCESSING_TASK.SCALE_TRANSFORMING: {
      selection_scale_transform.progress({
        x: mouse_move_point.x,
        y: mouse_move_point.y,
      });
      return;
    }
    case PROCESSING_TASK.PATH_EDITING_TRANSLATE_TRANSFORMING: {
      const _ctm = self._path_editor_target_el?.getCTM();
      if (_ctm == null) {
        return;
      }
      const ctm = _ctm;
      const transform = self._svg_el.createSVGTransform();
      transform.setTranslate(
        self._mouse_move_position.x - prev_mouse_move_position.x,
        self._mouse_move_position.y - prev_mouse_move_position.y
      );
      const matrix = ctm.inverse().multiply(transform.matrix).multiply(ctm);
      each(({ model }) => {
        model.transform(matrix);
      })(self._path_editor_list);
      const d = go(self._path_editor_list, last, (a) => a?.model?.toString());
      if (d != null) {
        self._path_editor_target_el?.setAttributeNS(null, "d", d);
      }
      return;
    }
    default: {
      return;
    }
  }
};
